// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"dec67cc2","945":"39cf18cf"}[chunkId] + ".chunk.js";
};